module.exports = "<h5>Charges</h5>\n<table class=\"table table-border line-item-table table-responsive\">\n  <thead>\n    <tr>\n      <th>1</th>\n      <th>2</th>\n      <th>3</th>\n      <th>4</th>\n      <th>5</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n    </tr>\n  </tbody>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/accountprofile/charges/charges.html
// module id = 625
// module chunks = 0